"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERegisterStatus = exports.ERegisterErrorType = void 0;
let ERegisterStatus = exports.ERegisterStatus = /*#__PURE__*/function (ERegisterStatus) {
  ERegisterStatus["Initial"] = "initial";
  ERegisterStatus["Loading"] = "loading";
  ERegisterStatus["Succeed"] = "succeed";
  ERegisterStatus["Failed"] = "failed";
  return ERegisterStatus;
}({});
let ERegisterErrorType = exports.ERegisterErrorType = /*#__PURE__*/function (ERegisterErrorType) {
  ERegisterErrorType["Common"] = "common";
  ERegisterErrorType["Email"] = "email";
  ERegisterErrorType["Password"] = "password";
  ERegisterErrorType["Phone"] = "phone";
  return ERegisterErrorType;
}({});